import React from 'react';
import PropTypes from 'prop-types';

const ListView = ({ data, className }) => (
  <ul className={className}>
    {data.map((item, index) => (
      <li key={index}>{item}</li>
    ))}
  </ul>
);

ListView.propTypes = {
  data: PropTypes.array.isRequired,
  className: PropTypes.string,
};

ListView.defaultProps = {
  className: '',
};

export default ListView;
